import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function StickyHeader() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-[#EAE5DC] shadow-sm" data-id="element-185">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between" data-id="element-186">
        <div className="flex items-center gap-2 text-sm font-medium" data-id="element-187">
          <ShieldIcon className="w-4 h-4 text-[#5BB4A0]" data-id="element-188" />
          <span className="text-[#1A1A1A]" data-id="element-189">TOOLS UNIVERSO™</span>
          <span className="text-[#6B7280] hidden sm:inline" data-id="element-190">
            — Edición 2026
          </span>
        </div>
        <button onClick={scrollToPricing} className="text-sm font-medium bg-[#5BB4A0] text-white px-4 py-1.5 rounded-full hover:bg-[#4A9382] transition-colors shadow-sm" data-id="element-191">
          → Quiero mi Kit
        </button>
      </div>
    </div>;
}